// Dashboard Vuex

import state from './dashboardStates.js'
import * as getters from './dashboardGetters.js'
import * as mutations from './dashboardMutations.js'
import * as actions from './dashboardActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
